import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DialogBox, Button } from 'xm-spark';
import classnames from 'classnames';
import { extendSession, logout } from 'services/sessionService';

import style from './SessionTimeout.module.scss';

export default function SessionTimeout({ isOpen, maxSessionDuration, time }) {
  const onClose = () => {
    extendSession(maxSessionDuration);
  };

  const seconds = time % 60;
  const minutes = parseInt(time / 60, 10);
  const secondsTimer = seconds < 10 ? `0${seconds}` : seconds;
  const minutesTimer = minutes < 10 ? `0${minutes}` : minutes;

  return (
    <DialogBox
      simpleStyle
      onClose={onClose}
      isOpen={isOpen}
      titleText={<FormattedMessage id="SESSION_TIMEOUT" />}
      centerButtons={[
        <Button
          className={classnames('button-primary')}
          key="confirm"
          onClick={onClose}
          data-testid="extend-session"
        >
          <FormattedMessage id="SESSION_TIMEOUT_EXTEND" />
        </Button>,
        <Button key="cancel" onClick={logout} data-testid="end-session">
          <FormattedMessage id="SESSION_TIMEOUT_LOGOUT" />
        </Button>,
      ]}
      classes={{
        wrap: classnames(style.modalDialog),
        header: style.header,
        title: style.title,
        buttons: style.buttons,
        content: style.content,
      }}
    >
      <FormattedMessage id="SESSION_TIMEOUT_WARNING" />
      <div className={style.timer}>
        {minutesTimer}:{secondsTimer}
      </div>
    </DialogBox>
  );
}

SessionTimeout.displayName = 'SessionTimeout';

SessionTimeout.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  maxSessionDuration: PropTypes.number,
  time: PropTypes.number,
};

SessionTimeout.defaultProps = {
  time: 0,
  maxSessionDuration: 0,
};
